import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { ProductField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/DataProviders/ProductField'

export const ProductsTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Name',
    align: 'start',
    key: ProductField.PRODUCT_NAME,
    sortable: false,
    placeholder: 'Product Name',
  },
  {
    title: 'Category',
    align: 'start',
    key: 'PRODUCT_CATEGORY_NAME',
    sortable: false,
    placeholder: 'Category Name',
  },
  {
    title: 'Price',
    align: 'start',
    key: ProductField.PRICE,
    sortable: false,
    placeholder: '$0.00',
  },
  {
    title: 'Type',
    align: 'start',
    key: ProductField.TYPE,
    sortable: false,
    placeholder: 'Standard',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
